import { createEntitySelectorHook } from "../../utils/createEntitySelectorHook";
import { menuSelectors } from "../selectors";
import { TAppMenu, TMenuIds } from "../types";

export const useMenuSelectors: (id: TMenuIds) => TAppMenu =
  createEntitySelectorHook(menuSelectors);
